'use client'

import { useEffectOnce } from '@/lib/hooks/memo-hooks'
import { sendGTMEvent } from '@next/third-parties/google'

type GTMIdentifyProps = {
    version: string
    env: string
    region: string
    userId?: string
    accountId?: string
}

export function GTMIdentify({ version, env, region, userId, accountId }: GTMIdentifyProps) {
    useEffectOnce(() => {
        sendGTMEvent({
            event: "identify",
            version,
            env,
            region,
            userId,
            accountId
        })
    })
    return null
}
